// Journal officiel des évolutions OFF MARKETTE — éditable à chaque nouvelle version.

export const STATUS = {
  available: { label: "Disponible", color: "#22c55e", dot: "bg-green-500", ring: "ring-green-500/30", text: "text-green-400" },
  in_progress: { label: "En cours de développement", color: "#eab308", dot: "bg-yellow-500", ring: "ring-yellow-500/30", text: "text-yellow-400" },
  testing: { label: "En test", color: "#3b82f6", dot: "bg-blue-500", ring: "ring-blue-500/30", text: "text-blue-400" },
  planned: { label: "Prévu", color: "#ef4444", dot: "bg-red-500", ring: "ring-red-500/30", text: "text-red-400" },
};

export const CATEGORIES = [
  "Annonces",
  "Back-office",
  "IA",
  "Automatisations",
  "Design",
  "Monétisation",
  "Performances",
  "SEO",
  "Application mobile",
  "Corrections de bugs",
  "Nouveautés",
];

// Grands axes de développement — servent de titres de section dans le journal.
// L'ordre de ce tableau définit l'ordre d'affichage des sections (des fondations aux nouveautés).
export const PHASES = [
  {
    key: "fondations", icon: "🏛️", title: "Fondations & site vitrine",
    desc: "La base solide de la plateforme : site public élégant, moteur de recherche, back-office de gestion, sécurité et confidentialité des annonces off-market.",
    acquereur: "Un site clair et rassurant pour découvrir des biens confidentiels, avec une recherche simple et des fiches complètes.",
    vendeur: "Une vitrine professionnelle et sécurisée qui valorise chaque bien tout en préservant la confidentialité du off-market.",
  },
  {
    key: "ia", icon: "🤖", title: "Intelligence artificielle",
    desc: "L'IA au cœur du produit : rédaction des fiches, contenu de quartier géolocalisé, home staging virtuel, import automatique d'annonces et assistant conversationnel disponible en continu.",
    acquereur: "Des fiches plus riches, un quartier expliqué (commerces, écoles, atouts), des visuels projetés et un assistant qui répond 24h/24.",
    vendeur: "Une annonce créée en quelques secondes, mise en valeur par l'IA (texte, home staging), sans ressaisie ni frais de rédaction.",
  },
  {
    key: "immersif", icon: "🏠", title: "Fiches immersives & participatif",
    desc: "Une expérience de visite haut de gamme (galerie plein écran, storytelling, sections dynamiques) et un parcours vendeur complet pour proposer son bien.",
    acquereur: "Une visite en ligne mémorable, comme dans les plus belles agences, pour se projeter avant même le premier rendez-vous.",
    vendeur: "Une présentation prestigieuse de son bien et un parcours simple pour confier une vente, en ligne comme off-market.",
  },
  {
    key: "design", icon: "✨", title: "Design premium & multimédia",
    desc: "Raffinement visuel continu : animations élégantes, apparitions au scroll, héros multimédia vidéo/photos 16:9 avec son, cohérence de marque sur toutes les pages.",
    acquereur: "Une navigation fluide et immersive qui donne immédiatement envie de découvrir les biens et le réseau.",
    vendeur: "Une image de marque haut de gamme qui rejaillit sur son bien et inspire confiance aux acheteurs.",
  },
  {
    key: "reseau", icon: "👥", title: "Réseau multi-conseillers",
    desc: "Ouverture de la plateforme à tout un réseau : inscription des conseillers, espaces personnels, pages publiques individuelles, annuaire, recherche avancée, statistiques et gestion des affiliations.",
    acquereur: "Le choix parmi de nombreux conseillers et biens, avec un interlocuteur dédié et une recherche ultra-précise (ville, secteur, conseiller).",
    vendeur: "Un large réseau de conseillers pour diffuser et vendre son bien, chacun disposant de sa propre vitrine et de ses statistiques.",
  },
  {
    key: "monetisation", icon: "💳", title: "Monétisation & crédits",
    desc: "Modèle économique complet : crédits d'annonces, packs à remise dégressive payés via Stripe, niveaux de mise en avant, essai gratuit, codes promo et rétrocommissions de parrainage multi-niveaux.",
    acquereur: "Des annonces mieux mises en avant et un réseau pérenne, gage de sérieux et de suivi dans la durée.",
    vendeur: "Une visibilité premium selon le niveau choisi (Standard, Premium, Prestige) et des conseillers motivés par un modèle rémunérateur.",
  },
  {
    key: "acquereur", icon: "🎙️", title: "Espace acquéreur & assistant IA",
    desc: "Captation intelligente des projets d'achat, à l'écrit comme à la voix : compte personnel, récapitulatif IA des critères, mode anonyme, et préparation du matching automatique acquéreurs / biens.",
    acquereur: "Décrire son projet en une phrase (ou à la voix), le sauvegarder sur son compte et être alerté en priorité sur les biens confidentiels correspondants.",
    vendeur: "Un vivier d'acquéreurs qualifiés et pré-enregistrés, prêts à être rapprochés d'un bien dès sa mise en off-market.",
  },
  {
    key: "sites", icon: "🌐", title: "Sites personnalisés des partenaires",
    desc: "Chaque conseiller dispose de son propre site internet à son image (couleur, logo, pages, bannières), généré et enrichi par IA, avec galeries, partenaires locaux, actualités/SEO local et formulaire de contact vocal. Mise en ligne via abonnement et nom de domaine dédié.",
    acquereur: "Retrouver chaque conseiller sur un site clair et personnel, avec ses biens et un contact direct simplifié.",
    vendeur: "Un site professionnel clé en main à son image pour développer sa marque et capter de nouveaux mandats sans compétence technique.",
  },
  {
    key: "transactions", icon: "✍️", title: "Transactions digitalisées",
    desc: "Le parcours transactionnel en ligne : offre d'achat officielle, génération des avant-contrats (compromis & promesse), signature électronique certifiée (DocuSign) et co-mandat entre partenaires avec partage d'honoraires et relevés de rétrocommission.",
    acquereur: "Déposer une offre officielle en quelques minutes et signer à distance, en toute sécurité et sans déplacement.",
    vendeur: "Un suivi transparent des offres, des avant-contrats prêts à valider par le notaire et une signature électronique certifiée.",
  },
  {
    key: "international", icon: "🌍", title: "International & multilingue",
    desc: "OFF MARKETTE devient nativement multilingue (Français, English, Español, Deutsch, Português, 简体中文) : vitrine publique traduite, traduction IA des annonces, détection automatique de la langue selon le pays, e-mails envoyés dans la langue de chaque membre, et un référencement optimisé pour les moteurs de recherche classiques comme pour les moteurs IA.",
    acquereur: "Découvrir les biens dans sa propre langue, où que l'on se trouve dans le monde, et recevoir des communications claires et personnalisées.",
    vendeur: "Toucher une clientèle internationale d'acquéreurs et gagner en visibilité sur Google et les assistants IA.",
  },
  {
    key: "agent", icon: "🎯", title: "Mon Agent IA — prospection autonome",
    desc: "Un agent commercial virtuel (« Emma ») qui détecte les acquéreurs sur tous les canaux, prépare et envoie les mises en relation, relance au bon moment, et pilote un mini-CRM complet (fiches prospects, statuts, Kanban, visites) — dans le respect du RGPD.",
    acquereur: "Être recontacté vite et au bon moment sur un bien qui correspond vraiment à son projet.",
    vendeur: "Un agent qui travaille en continu pour trouver l'acquéreur idéal de son bien, sans effort de sa part.",
  },
  {
    key: "jalons", icon: "🚩", title: "Jalons majeurs & déploiement",
    desc: "Les grandes étapes de lancement et de déploiement progressif du réseau OFF MARKETTE.",
    acquereur: "Une plateforme qui s'enrichit en continu, avec toujours plus de biens et de services.",
    vendeur: "Un réseau en expansion nationale, synonyme de plus d'acheteurs potentiels pour son bien.",
  },
];

export const LAST_UPDATE = { version: "5.10.0", date: "22 septembre 2026" };

// Historique réel du développement (le plus récent en premier).
// `phase` = grand axe de développement (voir PHASES).
export const TIMELINE = [
  {
    id: "v5-10-0",
    date: "2026-09-22",
    time: "17:40",
    version: "5.10.0",
    category: "Design",
    phase: "fondations",
    status: "available",
    developer: "Équipe OFF MARKETTE",
    title: "Refonte front-office : philosophie cinématique, réseau fondateur & site multilingue complet",
    description:
      "Grande passe d'harmonisation du site vitrine. La page Philosophie s'ouvre désormais sur une bannière vidéo cinématique des fondateurs (avec fondu sonore élégant), textes repositionnés en bas à gauche. La page « Notre réseau » et le bandeau « Nous rejoindre » affichent une photo d'équipe fondatrice haute définition dans un décor de Chantilly, avec les vrais visages de l'équipe (Vincent, Sébastien, Allison, Olivier, Michel). Un nouveau hero « Nous rejoindre » montre les 5 fondateurs autour d'un bureau partagé. Le bloc acheteur/vendeur redondant a été retiré de la page « Nous rejoindre ». Menu allégé (police du menu de départ) et titres de la section « Découvrir » mis en gras. Cohérence de vocabulaire : « Services » devient « Expertises » partout.",
    benefits: [
      "Page Philosophie : intro vidéo cinématique des fondateurs avec fondu sonore",
      "Photos d'équipe réalistes (décor Chantilly) sur « Notre réseau » et « Nous rejoindre »",
      "Pages Philosophie, Expertises et Nous rejoindre entièrement traduites en 6 langues (FR, EN, ES, DE, PT, ZH)",
      "Vocabulaire harmonisé « Expertises » et menu plus aéré",
      "Journal des évolutions réservé aux administrateurs",
    ],
    links: [],
  },
  {
    id: "v5-9-1",
    date: "2026-09-17",
    time: "19:30",
    version: "5.9.1",
    category: "Corrections de bugs",
    phase: "ia",
    status: "available",
    developer: "Équipe OFF MARKETTE",
    title: "Import Century 21 : galerie complète, sans doublon ni photo d'agence",
    description:
      "L'import depuis une annonce Century 21 récupère désormais TOUTE la galerie du bien en haute définition, dans le bon ordre. Correction de trois défauts constatés : la première photo n'apparaît plus en double, la vitrine/photo de l'agence n'est plus importée, et les visuels marketing (bannières « estimation ») ne créent plus de vignettes vides. Un garde-fou isole le bien affiché des éventuels biens similaires de la page.",
    benefits: [
      "Toutes les vraies photos du bien, en haute définition",
      "Fini les doublons et les vignettes vides",
      "Plus de photo d'agence ni de bannière marketing importée",
    ],
    links: [],
  },
  {
    id: "v5-9-0",
    date: "2026-09-17",
    time: "18:00",
    version: "5.9.0",
    category: "Annonces",
    phase: "ia",
    status: "available",
    developer: "Équipe OFF MARKETTE",
    title: "Import d'annonce nouvelle génération : aperçu, galerie complète & photos multiples",
    description:
      "L'import d'une annonce depuis un lien passe au niveau supérieur. Avant toute création, un écran d'aperçu présente l'annonce détectée (titre, prix, surface, localisation) et TOUTES les photos du bien — en écartant automatiquement les photos des « biens similaires » affichés sur la même page. Vous cochez ou décochez les visuels à conserver, puis vous validez. Dans l'édition d'une annonce, il est désormais possible d'ajouter plusieurs photos d'un coup sans écraser les existantes. Enfin, depuis l'onglet Audit, un bouton « Récupérer les photos manquantes » ré-analyse le lien d'origine et ajoute uniquement les photos absentes, sans jamais toucher à vos textes ni à vos mises en scène.",
    benefits: [
      "Une galerie fidèle au bien, sans photos parasites d'autres annonces",
      "Vous validez les photos avant de créer la fiche",
      "Ajout de plusieurs photos en une seule fois, sans perdre l'existant",
      "Rattraper une ancienne annonce incomplète en un clic depuis l'Audit",
    ],
    links: [],
  },
  {
    id: "v5-8-2",
    date: "2026-09-15",
    time: "16:00",
    version: "5.8.2",
    category: "IA",
    phase: "ia",
    status: "available",
    developer: "Équipe OFF MARKETTE",
    title: "Home Staging IA sur toutes les photos & navigation pièce par pièce",
    description:
      "Le home staging par IA ne se limite plus à la photo principale : chaque pièce d'un bien peut recevoir son propre rendu meublé et décoré, avec l'architecture, les murs et les volumes fidèlement préservés. Sur la fiche publique, une bande de miniatures permet de passer d'une pièce à l'autre, et le curseur avant/après se recale automatiquement à chaque changement. Les différents styles (Contemporain, Scandinave, Luxe…) restent sélectionnables par onglets.",
    benefits: [
      "Projeter les acquéreurs dans chaque pièce, pas seulement le salon",
      "Une navigation pièce par pièce fluide et élégante",
      "Le choix du style, pour chaque ambiance",
    ],
    links: [],
  },
  {
    id: "v5-8-1",
    date: "2026-09-12",
    time: "11:30",
    version: "5.8.1",
    category: "Corrections de bugs",
    phase: "sites",
    status: "available",
    developer: "Équipe OFF MARKETTE",
    title: "Corrections : photos des e-mails, carte de quartier & code postal",
    description:
      "Vague de corrections importantes : les photos intégrées aux e-mails s'affichent désormais de façon fiable, même lorsqu'un message en contient beaucoup (chargement optimisé côté serveur). La carte de quartier réapparaît sur toutes les fiches, y compris les annonces sans contenu IA. Enfin, le code postal affiché correspond toujours à la bonne commune, sans repli erroné.",
    benefits: [
      "Des e-mails dont toutes les photos s'affichent correctement",
      "La carte de quartier présente sur chaque fiche",
      "Une localisation toujours exacte",
    ],
    links: [],
  },
  {
    id: "v5-8-0",
    date: "2026-09-11",
    time: "15:00",
    version: "5.8.0",
    category: "Design",
    phase: "sites",
    status: "available",
    developer: "Équipe OFF MARKETTE",
    title: "Sites personnalisés : marque, logo & pied de page dynamiques",
    description:
      "Les sites personnalisés des conseillers gagnent en cohérence de marque : le logo reprend le nom du conseiller, le titre d'accueil met en avant l'enseigne ou le réseau, et le pied de page de chaque fiche affiche dynamiquement le nom du propriétaire du bien (fini les mentions figées). La lisibilité de la bannière a également été renforcée sur les photos claires.",
    benefits: [
      "Une identité de marque homogène sur tout le site du conseiller",
      "Le bon nom au bon endroit, automatiquement",
      "Une bannière toujours lisible, quelle que soit la photo",
    ],
    links: [],
  },
  {
    id: "v5-7-2",
    date: "2026-09-10",
    time: "10:00",
    version: "5.7.2",
    category: "Nouveautés",
    phase: "sites",
    status: "available",
    developer: "Équipe OFF MARKETTE",
    title: "Sites par réseau : thème Century 21 & « Je revendique mon site »",
    description:
      "OFF MARKETTE s'adapte à l'enseigne de chaque conseiller : un thème visuel dédié se déclenche automatiquement selon le réseau indiqué dans le profil (par exemple Century 21 : ambiance sombre premium, accents beige et or). Nouveau parcours « Je revendique mon site » : un conseiller pré-référencé peut reprendre la main sur son site en un instant — création de son accès et connexion immédiate — sans attendre de validation.",
    benefits: [
      "Un site aux couleurs de son enseigne, sans aucun réglage",
      "Reprendre la main sur son site en quelques secondes",
      "Un réseau prêt à accueillir de nouvelles enseignes",
    ],
    links: [],
  },
  {
    id: "v5-7-1",
    date: "2026-09-09",
    time: "17:00",
    version: "5.7.1",
    category: "Monétisation",
    phase: "monetisation",
    status: "available",
    developer: "Équipe OFF MARKETTE",
    title: "Boost : mettre un bien en avant (paiement à l'acte)",
    description:
      "Un conseiller peut désormais mettre en avant l'un de ses biens grâce à l'option « Boost », payable à l'acte (7 ou 30 jours, via Stripe). Le bien boosté remonte en tête des résultats de recherche publics et devient prioritaire dans le matching du réseau, tout en arborant un badge « Boosté ».",
    benefits: [
      "Donner un coup de projecteur à un bien au bon moment",
      "Plus de visibilité = plus de contacts acquéreurs",
      "Un paiement simple, à l'acte, sans abonnement",
    ],
    links: [],
  },
  {
    id: "v5-7-0",
    date: "2026-09-08",
    time: "12:00",
    version: "5.7.0",
    category: "Automatisations",
    phase: "reseau",
    status: "available",
    developer: "Équipe OFF MARKETTE",
    title: "Partenariat en 1 clic & « Proposer le match » depuis le matching",
    description:
      "Depuis le matching, un conseiller peut nouer un partenariat en un clic avec un confrère dont un acquéreur correspond à son bien, ou lui « proposer le match » via une fiche structurée (photo, deux aperçus de home staging, attribution stricte — l'identité de l'acquéreur n'est jamais dévoilée). Le barème de rétrocommission s'adapte automatiquement au nombre d'acquéreurs concernés (partenariat réseau simple ou co-mandat 75/25). Les propositions reçues se gèrent depuis l'onglet Co-mandats.",
    benefits: [
      "Collaborer en un clic quand un confrère a le bon acheteur",
      "Un partage d'honoraires clair et calculé automatiquement",
      "La confidentialité des acquéreurs toujours préservée",
    ],
    links: [],
  },
  {
    id: "v5-6-1",
    date: "2026-09-07",
    time: "18:00",
    version: "5.6.1",
    category: "Automatisations",
    phase: "agent",
    status: "available",
    developer: "Équipe OFF MARKETTE",
    title: "Prospects : vue Kanban, visites planifiées & récap quotidien",
    description:
      "Le mini-CRM des prospects s'enrichit : une vue Kanban par statut (du prospect détecté jusqu'à la vente) avec déplacement d'une colonne à l'autre, la planification de visites avec rappel automatique la veille (au conseiller ET à l'acquéreur), la proposition de créneaux par e-mail, et un récapitulatif quotidien réglable (fréquence et heure d'envoi) qui met en avant vos prospects les plus chauds du jour.",
    benefits: [
      "Visualiser tout son pipeline commercial d'un coup d'œil",
      "Ne manquer aucune visite grâce aux rappels automatiques",
      "Commencer chaque journée par les bonnes priorités",
    ],
    links: [],
  },
  {
    id: "v5-6-0",
    date: "2026-09-06",
    time: "15:30",
    version: "5.6.0",
    category: "Nouveautés",
    phase: "agent",
    status: "available",
    developer: "Équipe OFF MARKETTE",
    title: "Emma, votre agent IA : page de découverte & film de présentation",
    description:
      "Votre agent IA a désormais un visage : « Emma ». Une page de découverte dédiée (réservée aux conseillers) explique son fonctionnement — comment elle détecte les acquéreurs, prépare les mises en relation et travaille en continu — accompagnée d'un film de présentation interactif. Un bloc « Emma a travaillé pour vous » affiche en temps réel les prospects détectés, les e-mails préparés et les correspondances trouvées depuis votre dernière visite.",
    benefits: [
      "Comprendre en un instant ce que votre agent IA fait pour vous",
      "Un récapitulatif vivant de son travail au quotidien",
      "Un allié commercial disponible 24h/24",
    ],
    links: [],
  },
  {
    id: "v5-5-1",
    date: "2026-09-05",
    time: "14:00",
    version: "5.5.1",
    category: "Automatisations",
    phase: "agent",
    status: "available",
    developer: "Équipe OFF MARKETTE",
    title: "Radar multicanal & brouillons de messages (WhatsApp)",
    description:
      "Pour chaque prospect, l'Agent IA indique les canaux de contact disponibles (e-mail, WhatsApp, Facebook, Instagram) et recommande le canal le plus pertinent. Il peut préparer un brouillon de message WhatsApp court et personnalisé, avec lien de suivi, prêt à copier — aucun envoi automatique, vous gardez toujours la main.",
    benefits: [
      "Contacter chaque prospect sur le bon canal",
      "Un message prêt à l'emploi en quelques secondes",
      "Vous validez toujours avant d'envoyer",
    ],
    links: [],
  },
  {
    id: "v5-5-0",
    date: "2026-09-04",
    time: "11:00",
    version: "5.5.0",
    category: "Nouveautés",
    phase: "agent",
    status: "available",
    developer: "Équipe OFF MARKETTE",
    title: "Mon Agent IA : mini-CRM des prospects",
    description:
      "Naissance de « Mon Agent IA » : chaque recherche d'acquéreur détectée devient une fiche prospect actionnable, regroupée dans un mini-CRM. Recherche rapide, filtres (plus chauds, nouveaux, e-mail prêt / envoyé / ouvert…), score d'intérêt, statut commercial en 11 étapes, prochaine action conseillée et historique complet. Les coordonnées sont automatiquement masquées lorsque le prospect a été repéré publiquement sans consentement, dans le respect du RGPD.",
    benefits: [
      "Toutes vos pistes acquéreurs centralisées et priorisées",
      "Savoir quelle est la prochaine action pour chaque prospect",
      "Une prospection conforme au RGPD",
    ],
    links: [],
  },
  {
    id: "v5-4-4",
    date: "2026-09-03",
    time: "18:30",
    version: "5.4.4",
    category: "Automatisations",
    phase: "ia",
    status: "available",
    developer: "Équipe OFF MARKETTE",
    title: "Relance automatique des prospects intéressés",
    description:
      "Votre Agent IA relance tout seul les prospects qui ont OUVERT votre e-mail sans cliquer, au bout de 3 jours (jusqu'à 2 relances espacées). En mode « Validation », la relance attend votre feu vert dans la file d'attente ; en mode « Automatique », elle part seule. Le contenu déjà rédigé est réutilisé pour maîtriser le coût IA.",
    benefits: [
      "Ne plus jamais laisser filer un prospect tiède",
      "Des relances au bon moment, sans y penser",
      "Coût IA maîtrisé (aucun texte regénéré inutilement)",
    ],
    links: [],
  },
  {
    id: "v5-4-3",
    date: "2026-09-03",
    time: "18:00",
    version: "5.4.3",
    category: "IA",
    phase: "ia",
    status: "available",
    developer: "Équipe OFF MARKETTE",
    title: "Podium des conseillers du mois",
    description:
      "Une nouvelle section (réservée au super administrateur) classe les conseillers les plus performants du mois selon le critère de votre choix : score de performance combiné, taux de clic, commissions réalisées ou nombre d'e-mails envoyés. Un sélecteur permet de revoir les mois précédents.",
    benefits: [
      "Voir en un coup d'œil qui performe",
      "Animer et motiver l'ensemble du réseau",
      "Analyser les résultats mois par mois",
    ],
    links: [],
  },
  {
    id: "v5-4-2",
    date: "2026-09-03",
    time: "17:30",
    version: "5.4.2",
    category: "IA",
    phase: "ia",
    status: "available",
    developer: "Équipe OFF MARKETTE",
    title: "Vue Super Admin transversale de l'Agent IA",
    description:
      "Le super administrateur suit désormais toute l'activité de l'Agent IA du réseau : prospects, e-mails envoyés, taux d'ouverture et de clic, coûts IA et commissions — conseiller par conseiller — avec la possibilité de lire chaque e-mail envoyé et sa source. Disponible dans le back-office (onglet « Agent IA ») et dans Mon espace › Administration.",
    benefits: [
      "Piloter la prospection de tout le réseau",
      "Lire n'importe quel e-mail envoyé et sa source",
      "Suivre les coûts IA et les commissions générées",
    ],
    links: [],
  },
  {
    id: "v5-4-1",
    date: "2026-09-03",
    time: "16:45",
    version: "5.4.1",
    category: "Automatisations",
    phase: "ia",
    status: "available",
    developer: "Équipe OFF MARKETTE",
    title: "Modes Automatique / Validation par conseiller",
    description:
      "Chaque conseiller choisit comment son Agent IA envoie ses e-mails de prospection : en « Validation » (chaque e-mail attend son approbation dans une file d'attente, avec aperçu + boutons Valider/Rejeter) ou en « Automatique » (envoi immédiat). Par sécurité, les nouveaux conseillers démarrent en mode Validation.",
    benefits: [
      "Garder la main sur chaque envoi",
      "Passer en pilote automatique quand on est en confiance",
      "Valider ou rejeter un e-mail en un clic",
    ],
    links: [],
  },
  {
    id: "v5-4-0",
    date: "2026-09-03",
    time: "16:00",
    version: "5.4.0",
    category: "IA",
    phase: "ia",
    status: "available",
    developer: "Équipe OFF MARKETTE",
    title: "E-mails réactivés + contexte de la prise de contact",
    description:
      "Les e-mails de l'Agent IA repartent (canal d'envoi de secours activé). Surtout, chaque e-mail précise désormais OÙ la recherche du prospect a été repérée (groupe Facebook, forum immobilier, en ligne…), pour un premier contact naturel et pertinent — comme si vous aviez vu sa demande vous-même et pris soin de le recontacter.",
    benefits: [
      "Des e-mails de prospection qui repartent immédiatement",
      "Un premier contact crédible, humain et personnalisé",
      "Une meilleure pertinence perçue → plus de réponses",
    ],
    links: [],
  },
  {
    id: "v5-3-0",
    date: "2026-08-13",
    time: "17:30",
    version: "5.3.0",
    category: "SEO",
    phase: "international",
    status: "available",
    developer: "Équipe OFF MARKETTE",
    title: "Référencement local (Google) & présence sur les moteurs IA",
    description:
      "Un pack de référencement complet pour être trouvé partout : données structurées géolocalisées (agence immobilière, zone desservie, coordonnées) et fiche enrichie pour chaque annonce (prix, surface, localisation, coordonnées GPS) que Google comprend et met en avant. Ouverture explicite aux moteurs et assistants IA (ChatGPT, Perplexity, Google AI, Claude…) via un fichier dédié qui leur explique notre métier, l'immobilier off-market et select, notre zone d'action et nos pages clés — pour être cité dans leurs réponses. Ajout d'un plan de site multilingue (6 langues) et d'une nouvelle page pédagogique « L'immobilier off-market ».",
    benefits: [
      "Apparaître sur Google avec des informations riches (prix, localisation, agence)",
      "Être cité par les assistants IA quand on parle d'immobilier off-market",
      "Une visibilité renforcée dans les 6 langues du site",
    ],
    links: [],
  },
  {
    id: "v5-2-0",
    date: "2026-08-13",
    time: "16:00",
    version: "5.2.0",
    category: "Automatisations",
    phase: "international",
    status: "available",
    developer: "Équipe OFF MARKETTE",
    title: "E-mails envoyés dans la langue de chaque membre",
    description:
      "Chaque membre choisit sa langue préférée (à l'inscription et dans son profil, rubrique « Langue de mes e-mails »). Tous les e-mails automatiques (bienvenue, offres, co-mandats, justificatifs, rappels…) lui sont alors envoyés dans cette langue, traduits automatiquement par l'IA tout en préservant les montants, les liens et la mise en forme. Chaque traduction est mémorisée pour être instantanée les fois suivantes.",
    benefits: [
      "Des e-mails compris par chaque membre, dans sa langue",
      "Une expérience premium pour une clientèle internationale",
      "Aucune ressaisie : traduction automatique et fidèle",
    ],
    links: [],
  },
  {
    id: "v5-1-0",
    date: "2026-08-13",
    time: "14:30",
    version: "5.1.0",
    category: "Nouveautés",
    phase: "international",
    status: "available",
    developer: "Équipe OFF MARKETTE",
    title: "Langue proposée automatiquement selon le pays",
    description:
      "Le site détecte le pays du visiteur (via son adresse réseau, avec repli sur la langue de son navigateur) et lui propose discrètement, par une petite bannière, d'afficher le site dans la langue de son pays (« ¿Ver el sitio en Español? », « View this site in English? »…). La proposition n'est jamais imposée et respecte tout choix manuel de l'utilisateur.",
    benefits: [
      "Un visiteur étranger se sent immédiatement chez lui",
      "Une proposition élégante et non intrusive",
      "Le choix de langue de l'utilisateur toujours respecté",
    ],
    links: [],
  },
  {
    id: "v5-0-0",
    date: "2026-08-13",
    time: "12:00",
    version: "5.0.0",
    category: "Nouveautés",
    phase: "international",
    status: "available",
    developer: "Équipe OFF MARKETTE",
    title: "Site multilingue : 6 langues (FR, EN, ES, DE, PT, 中文)",
    description:
      "OFF MARKETTE devient nativement multilingue. Toute la vitrine publique (accueil, recherche, page annonces, cartes de biens) est traduite en français, anglais, espagnol, allemand, portugais et chinois simplifié. Les titres et descriptions des annonces sont traduits par l'IA puis mémorisés (traduits une seule fois, sans surcoût), et des adresses par langue (/fr, /en, /es…) sont prévues pour le référencement. Un sélecteur de langue est disponible dans le menu.",
    benefits: [
      "Toucher une clientèle internationale d'acquéreurs",
      "Des annonces traduites automatiquement par l'IA",
      "Un sélecteur de langue simple, partout sur le site",
    ],
    links: [],
  },
  {
    id: "v4-9-0",
    date: "2026-08-10",
    time: "11:00",
    version: "4.9.0",
    category: "Automatisations",
    phase: "transactions",
    status: "available",
    developer: "Équipe OFF MARKETTE",
    title: "Co-mandats : signature, honoraires & comptabilité",
    description:
      "Le co-mandat entre partenaires est finalisé de bout en bout : signature de l'accord par les deux conseillers, calcul automatique du partage d'honoraires avec la part plateforme OFF MARKETTE (2 %), suivi du statut de paiement, génération d'un justificatif de versement en PDF, exports comptables (CSV/PDF) et rappels automatiques pour les versements en attente.",
    benefits: [
      "Une collaboration entre conseillers claire et sécurisée",
      "Des justificatifs et exports prêts pour la comptabilité",
      "Des rappels automatiques pour ne rien oublier",
    ],
    links: [],
  },
  {
    id: "v-meta-social",
    date: "2026-07-30",
    time: "18:00",
    version: "4.6.0",
    category: "Automatisations",
    phase: "reseau",
    status: "in_progress",
    developer: "Équipe OFF MARKETTE",
    title: "Publication en un clic sur Facebook & Instagram (Meta)",
    description:
      "Connexion officielle aux réseaux Meta (Facebook & Instagram) pour publier une annonce directement depuis la plateforme, sans copier-coller. Le module actuel de partage assisté (texte optimisé par réseau + visuel avec logo incrusté) reste disponible en attendant la validation de l'application par Meta (App Review), étape obligatoire pour publier au nom de plusieurs comptes.",
    benefits: [
      "Publier une annonce sur Facebook et Instagram en un clic",
      "Gain de temps : plus besoin de copier-coller texte et visuels",
      "En attendant : le partage assisté (texte + image) reste en place",
    ],
    links: [],
  },
  {
    id: "v4-5-0",
    date: "2026-07-30",
    time: "16:30",
    version: "4.5.0",
    category: "IA",
    phase: "ia",
    status: "available",
    developer: "Équipe OFF MARKETTE",
    title: "2 mises en scène IA offertes, choix des styles & notification",
    description:
      "À la création d'un bien (via « Proposer un bien » ou depuis le back-office), deux home stagings par intelligence artificielle sont générés automatiquement et offerts, sur la photo principale de l'annonce. Le propriétaire choisit ses deux styles (Contemporain et Scandinave par défaut, parmi dix ambiances). Un badge « 2 mises en scène IA offertes » s'affiche en direct sur la carte pendant la génération, et le propriétaire reçoit un e-mail « Vos 2 mises en scène IA sont prêtes » avec un aperçu avant/après. Si le bien n'a pas encore de photo, une couverture élégante « Photo bientôt disponible » au logo OFF MARKETTE est créée automatiquement.",
    benefits: [
      "Un effet « waouh » immédiat : le potentiel du bien révélé sans effort",
      "Le propriétaire choisit lui-même l'ambiance de ses rendus",
      "Une notification e-mail avec aperçu avant/après pour inciter à publier",
      "Aucune annonce sans visuel grâce à la couverture de secours",
    ],
    links: [],
  },
  {
    id: "v4-4-2",
    date: "2026-07-30",
    time: "14:30",
    version: "4.4.2",
    category: "Nouveautés",
    phase: "monetisation",
    status: "available",
    developer: "Équipe OFF MARKETTE",
    title: "Parcours « Proposer un bien » unifié & changement de formule",
    description:
      "Le particulier qui propose un bien enchaîne désormais directement sur l'Assistant de publication en 7 étapes après création de son compte, pour un parcours fluide de bout en bout. Côté conseiller, il est possible de faire évoluer la formule d'une annonce (Classique → Pro → Premium) après coup : seule la différence de crédits est débitée en cas de montée en gamme (achat proposé si besoin), sans perdre le travail déjà réalisé.",
    benefits: [
      "Un dépôt de bien guidé du début à la fin, sans rupture",
      "Passer une annonce en gamme supérieure sans tout refaire",
      "Une facturation juste : uniquement la différence de crédits",
    ],
    links: [],
  },
  {
    id: "v4-4-1",
    date: "2026-07-30",
    time: "11:30",
    version: "4.4.1",
    category: "Corrections de bugs",
    phase: "sites",
    status: "available",
    developer: "Équipe OFF MARKETTE",
    title: "Profil fiable : photos, recadrage & identité harmonisée",
    description:
      "Refonte de l'espace « Mes informations » : les photos (profil, logo, galerie) s'enregistrent automatiquement dès l'ajout, avec aperçu immédiat et messages clairs en cas de souci. Un outil de recadrage (zoom et cadrage) est disponible pour la photo de profil et les bannières des pages du site personnalisé (cadrage vertical ajustable). L'identité (nom, société, logo) est désormais synchronisée partout — site personnalisé, page conseiller, e-mails. Le logo est mis en valeur, agrandi sur les sites personnalisés et sur la page de présentation.",
    benefits: [
      "Fini les photos qui « disparaissent » : tout est enregistré immédiatement",
      "Un recadrage simple pour des visuels toujours nets et bien cadrés",
      "Un nom et un logo cohérents sur l'ensemble de vos supports",
    ],
    links: [],
  },
  {
    id: "v4-3-0",
    date: "2026-07-28",
    time: "10:30",
    version: "4.3.0",
    category: "Design",
    phase: "design",
    status: "available",
    developer: "Équipe OFF MARKETTE",
    title: "Expérience premium : cartes vivantes, hero affiné & pédagogie off market",
    description:
      "Vague d'améliorations visuelles sur le site national et les sites personnalisés. Les vignettes d'annonces sont désormais entièrement cliquables et s'animent élégamment au survol (léger agrandissement + ombre douce, sans zoom brusque de la photo). Le hero d'accueil a été raffiné : effet verre plus net, titre allégé, badge « À la une » repositionné en pastille dorée, et disparition en fondu des textes au survol des boutons Photos / Home staging / Vidéo avec défilement automatique des visuels. Les boutons de partage arborent une icône dorée sur fond blanc avec un halo lumineux pulsant. Enfin, une nouvelle section « Pourquoi rejoindre OFF MARKETTE ? » explique le modèle off market (gains concrets et déroulé en 4 étapes), présente sur l'accueil national et sur chaque site de conseiller.",
    benefits: [
      "Une navigation plus intuitive : toute la carte d'un bien est cliquable",
      "Un accueil plus lisible et haut de gamme, moins chargé",
      "Le concept off market expliqué clairement (avantages + processus)",
      "Un partage des biens plus visible pour diffuser dans son réseau",
    ],
    links: [],
  },
  {
    id: "v4-2-0",
    date: "2026-07-18",
    time: "19:30",
    version: "4.2.0",
    category: "Annonces",
    phase: "immersif",
    status: "available",
    developer: "Équipe OFF MARKETTE",
    title: "Fiches annonces nouvelle génération : rareté IA & prix marché en direct",
    description:
      "Refonte premium des fiches annonces : section « Points Forts » centrée sur fond doré, rubriques de quartier en accordéons, en-tête épuré (menu mobile repensé, retour intégré) et sous-titre agrandi. Nouveauté majeure : une synthèse de rareté IA « Pourquoi ce bien est unique » générée pour chaque annonce, et un indicateur de prix au m² comparé en temps réel au marché local réel (données publiques DVF, data.gouv.fr). Le vendeur affiché est désormais dynamique et propre à chaque bien.",
    benefits: [
      "Chaque bien met en avant ce qui le rend rare, expliqué par l'IA",
      "Un prix au m² situé par rapport au marché réel de la commune",
      "Une lecture plus fluide et haut de gamme, surtout sur mobile",
    ],
    links: [],
  },
  {
    id: "v4-1-0",
    date: "2026-07-18",
    time: "16:00",
    version: "4.1.0",
    category: "Automatisations",
    phase: "transactions",
    status: "testing",
    developer: "Équipe OFF MARKETTE",
    title: "Signature électronique certifiée des contrats (DocuSign)",
    description:
      "Les offres d'achat et avant-contrats peuvent être envoyés en signature électronique certifiée via DocuSign, dans le bon ordre (acquéreur, puis vendeur, puis conseiller). Le statut de signature est suivi en direct et le document signé est archivé et téléchargeable. Fonction en cours de finalisation (activation du compte de signature).",
    benefits: [
      "Signer à distance, sans impression ni déplacement",
      "Une valeur juridique et une traçabilité renforcées",
      "Un gain de temps considérable sur chaque dossier",
    ],
    links: [],
  },
  {
    id: "v4-0-0",
    date: "2026-07-18",
    time: "12:30",
    version: "4.0.0",
    category: "Nouveautés",
    phase: "transactions",
    status: "available",
    developer: "Équipe OFF MARKETTE",
    title: "Transactions digitalisées : offre d'achat, avant-contrats & co-mandat",
    description:
      "Lancement du parcours transactionnel en ligne : dépôt d'une offre d'achat officielle avec génération automatique du PDF, création des avant-contrats (compromis et promesse de vente) en projet à valider par le notaire, et co-mandat entre partenaires avec partage d'honoraires (75/25) et relevés de rétrocommission automatiques.",
    benefits: [
      "Un acquéreur peut faire une offre officielle en quelques minutes",
      "Des documents générés automatiquement, prêts pour le notaire",
      "La collaboration entre conseillers récompensée et tracée",
    ],
    links: [],
  },
  {
    id: "v3-9-0",
    date: "2026-07-18",
    time: "10:00",
    version: "3.9.0",
    category: "Nouveautés",
    phase: "sites",
    status: "available",
    developer: "Équipe OFF MARKETTE",
    title: "Sites internet personnalisés pour chaque conseiller",
    description:
      "Chaque conseiller peut désormais disposer de son propre site à son image (couleur, logo, pages, bannières de couverture), généré et enrichi par IA : page d'accueil, présentation, actualités et SEO local. Le tout avec galeries photos/vidéos, partenaires locaux et un formulaire de contact intégrant la dictée vocale et l'amélioration IA du message. Mise en ligne via abonnement mensuel et nom de domaine personnalisé.",
    benefits: [
      "Un site professionnel clé en main, sans compétence technique",
      "Une marque personnelle renforcée pour capter des mandats",
      "Un contenu et un référencement local optimisés par l'IA",
    ],
    links: [],
  },
  {
    id: "v3-8-0",
    date: "2026-07-18",
    time: "09:00",
    version: "3.8.0",
    category: "Automatisations",
    phase: "reseau",
    status: "available",
    developer: "Équipe OFF MARKETTE",
    title: "Réseau collaboratif : partage de mandats & apports d'affaires",
    description:
      "Le réseau devient collaboratif : partage sélectif des annonces entre partenaires, recommandations de partenaires, groupes régionaux, statistiques de collaboration et suivi complet des apports d'affaires (contact → visite → offre → vendu) avec classement des meilleurs apporteurs.",
    benefits: [
      "Plus de biens diffusés = plus d'acheteurs potentiels",
      "Chaque mise en relation utile est valorisée",
      "Une dynamique d'entraide mesurable au sein du réseau",
    ],
    links: [],
  },
  {
    id: "v3-7-0",
    date: "2026-07-18",
    time: "08:00",
    version: "3.7.0",
    category: "Design",
    phase: "design",
    status: "available",
    developer: "Équipe OFF MARKETTE",
    title: "Page « Nous rejoindre » animée & bannières unifiées",
    description:
      "Nouvelle page de recrutement premium (présentation animée des fonctionnalités, inscription rapide par e-mail ou Google) et harmonisation des bannières de couverture sur tout le portail national. Ajout des métadonnées de partage social (aperçu enrichi lors du partage de liens) avec le nouveau logo K doré.",
    benefits: [
      "Une vitrine convaincante pour attirer de nouveaux conseillers",
      "Une identité visuelle cohérente sur toutes les pages",
      "Des liens partagés plus élégants sur les réseaux et messageries",
    ],
    links: [],
  },
  {
    id: "v3-6-0",
    date: "2026-07-17",
    time: "18:00",
    version: "3.6.0",
    category: "Nouveautés",
    phase: "acquereur",
    status: "available",
    developer: "Équipe OFF MARKETTE",
    title: "Espace Acquéreurs : compte personnel & récapitulatif IA",
    description:
      "Les acquéreurs peuvent désormais créer un compte (e-mail ou Google) pour sauvegarder leur recherche et être alertés en priorité sur les biens confidentiels correspondants. Un bouton « Générer le récapitulatif IA » synthétise instantanément tous les critères exprimés (budget, secteurs, type de bien, exigences, urgence). Le mode « sans compte » et l'anonymat restent possibles.",
    benefits: [
      "Fidéliser les acquéreurs avec un profil qui leur est propre",
      "Un récapitulatif clair et structuré de chaque projet d'achat",
      "Préparer le matching automatique acquéreurs / biens",
    ],
    links: [],
  },
  {
    id: "v3-5-0",
    date: "2026-07-17",
    time: "15:20",
    version: "3.5.0",
    category: "IA",
    phase: "acquereur",
    status: "available",
    developer: "Équipe OFF MARKETTE",
    title: "Assistant IA de présentation (vocal & texte)",
    description:
      "Un assistant à la ChatGPT rédige la présentation et la vision d'un conseiller à partir de quelques phrases dictées au micro (transcription vocale) ou saisies au clavier. Côté acquéreurs, le même moteur structure automatiquement les besoins exprimés. Contenus régénérables et éditables avant validation.",
    benefits: [
      "Une présentation professionnelle en quelques secondes",
      "La voix suffit : plus besoin de rédiger",
      "Des profils homogènes et soignés sur tout le réseau",
    ],
    links: [],
  },
  {
    id: "v3-4-0",
    date: "2026-07-17",
    time: "12:30",
    version: "3.4.0",
    category: "Back-office",
    phase: "reseau",
    status: "available",
    developer: "Équipe OFF MARKETTE",
    title: "Fiche conseiller enrichie & statistiques personnelles",
    description:
      "La page publique de chaque conseiller gagne en élégance : présentation centrée, photos d'ambiance sélectionnées automatiquement selon le profil, section « vision » sur visuel, et une galerie photos en mosaïque (jusqu'à 10 photos, téléversables toutes en une fois). Chaque conseiller dispose d'un onglet « Statistiques » dans son espace : nombre d'annonces, vues cumulées, visiteurs uniques, favoris et performance détaillée par bien.",
    benefits: [
      "Une vitrine plus séduisante pour chaque conseiller",
      "Piloter ses performances en toute autonomie",
      "Savoir quels biens attirent le plus l'attention",
    ],
    links: [],
  },
  {
    id: "v3-3-0",
    date: "2026-07-17",
    time: "09:15",
    version: "3.3.0",
    category: "Design",
    phase: "design",
    status: "available",
    developer: "Équipe OFF MARKETTE",
    title: "Hero multimédia (vidéo & photos)",
    description:
      "Les fiches biens et les pages conseillers peuvent afficher une vidéo plein écran 16:9 (YouTube, Vimeo ou fichier) prioritaire sur les photos, avec contrôle du son (activer/couper) et menus en transparence. À défaut de vidéo, un diaporama photo élégant prend le relais.",
    benefits: [
      "Un impact immédiat et immersif dès l'arrivée sur la page",
      "Mettre en valeur un bien ou un conseiller en mouvement",
      "Une image de marque à la hauteur du haut de gamme",
    ],
    links: [],
  },
  {
    id: "v3-2-5",
    date: "2026-07-17",
    time: "08:00",
    version: "3.2.5",
    category: "Monétisation",
    phase: "monetisation",
    status: "available",
    developer: "Équipe OFF MARKETTE",
    title: "Rétrocommissions de parrainage multi-niveaux",
    description:
      "Quand un conseiller parrainé achète des crédits, son parrain est récompensé en crédits d'annonces, sur plusieurs niveaux (10 % / 5 % / 2 % par défaut, paramétrable). Un tableau « Mes commissions » détaille les gains, le réseau de filleuls et l'historique.",
    benefits: [
      "Récompenser la croissance du réseau",
      "Motiver le parrainage de nouveaux conseillers",
      "Un modèle vertueux qui s'auto-alimente",
    ],
    links: [],
  },
  {
    id: "v3-2-3",
    date: "2026-07-17",
    time: "07:30",
    version: "3.2.3",
    category: "Monétisation",
    phase: "monetisation",
    status: "available",
    developer: "Équipe OFF MARKETTE",
    title: "Essai gratuit, aperçu IA & codes promo",
    description:
      "Chaque nouveau conseiller peut créer plusieurs annonces en prévisualisation gratuitement, avec un aperçu IA (texte, SEO et home staging) illimité avant paiement. Un système de codes promo (crédits offerts ou remise Stripe) est géré depuis le back-office.",
    benefits: [
      "Tester la plateforme sans engagement",
      "Découvrir la valeur de l'IA avant de payer",
      "Des leviers promotionnels pour accélérer l'adoption",
    ],
    links: [],
  },
  {
    id: "v3-2-1",
    date: "2026-07-17",
    time: "07:00",
    version: "3.2.1",
    category: "Monétisation",
    phase: "monetisation",
    status: "available",
    developer: "Équipe OFF MARKETTE",
    title: "Crédits d'annonces & paiement Stripe",
    description:
      "Mise en place du modèle économique : un portefeuille de crédits (1 crédit = 10 €), des packs à remise dégressive achetés en ligne via Stripe, et des niveaux d'annonce (Standard / Premium / Prestige). Les annonces sont créées en prévisualisation puis publiées en débitant les crédits.",
    benefits: [
      "Une source de revenus claire et récurrente",
      "Un paiement en ligne simple et sécurisé",
      "Des niveaux de mise en avant pour valoriser les biens",
    ],
    links: [],
  },
  {
    id: "v3-2-0",
    date: "2026-07-16",
    time: "23:10",
    version: "3.2.0",
    category: "Back-office",
    phase: "reseau",
    status: "available",
    developer: "Équipe OFF MARKETTE",
    title: "Statistiques du réseau & favoris",
    description:
      "Nouveau tableau de bord statistiques réservé au super administrateur : nombre de biens en ligne, vues totales, favoris, recherches, répartition des conseillers (validés / en attente / bloqués), classement des biens les plus vus et les plus mis en favori, villes et types les plus recherchés, et affiliations par mois. Côté public, un bouton « cœur » permet à chaque visiteur d'enregistrer ses biens favoris (page « Mes favoris ») ; ces interactions alimentent les statistiques de façon anonyme. Chaque fiche compte désormais ses vues, affichées dans le back-office.",
    benefits: [
      "Piloter la croissance du réseau d'un coup d'œil",
      "Identifier les biens et les secteurs qui attirent le plus",
      "Comprendre la demande réelle des acquéreurs pour mieux prospecter",
    ],
    links: [],
  },
  {
    id: "v3-1-0",
    date: "2026-07-16",
    time: "18:30",
    version: "3.1.0",
    category: "Annonces",
    phase: "reseau",
    status: "available",
    developer: "Équipe OFF MARKETTE",
    title: "Recherche avancée & annuaire des conseillers",
    description:
      "Le moteur de recherche des biens (nouvelle adresse « /biens-off-market ») se filtre désormais par ville, département, région, conseiller et agence. Un annuaire public « Nos conseillers & agents immobiliers » présente tous les partenaires du réseau, et chaque conseiller dispose d'une page publique dédiée (photo, présentation, coordonnées, portefeuille de biens) accessible via une URL personnalisée.",
    benefits: [
      "Trouver le bon bien ou le bon conseiller en quelques clics",
      "Donner de la visibilité à chaque partenaire du réseau",
      "Une vitrine individuelle pour chaque conseiller",
    ],
    links: [],
  },
  {
    id: "v3-0-0",
    date: "2026-07-16",
    time: "12:00",
    version: "3.0.0",
    category: "Nouveautés",
    phase: "reseau",
    status: "available",
    developer: "Équipe OFF MARKETTE",
    title: "Réseau multi-conseillers : inscription & espace membre",
    description:
      "OFF MARKETTE devient une véritable plateforme collaborative. Un conseiller peut créer son compte (e-mail ou Google), remplir sa vitrine (logo, photo, présentation) et gérer ses propres annonces depuis un espace personnel. Vincent valide chaque demande d'affiliation en un clic (avec notification et badge en temps réel), peut réaffecter un bien à un conseiller ou suspendre un compte. Un système de parrainage permet d'inviter de nouveaux conseillers par lien, WhatsApp ou e-mail. Chaque conseiller accède aussi au journal des évolutions depuis son espace.",
    benefits: [
      "Ouvrir la plateforme à tout un réseau de conseillers",
      "Chaque conseiller autonome sur ses propres biens",
      "Une croissance maîtrisée grâce à la validation et au parrainage",
    ],
    links: [],
  },
  {
    id: "v2-4-1",
    date: "2026-07-15",
    time: "16:45",
    version: "2.4.1",
    category: "Design",
    phase: "design",
    status: "available",
    developer: "Équipe OFF MARKETTE",
    title: "Refonte UI & animations premium",
    description:
      "Grande passe de raffinement visuel : logo header/footer recadré et animé, titres animés lettre par lettre, apparitions au scroll sur chaque section, cartes d'engagements et de services avec image révélée au survol, page « Proposez votre bien » repensée avec fond photo. L'objectif : une expérience plus chic, dynamique et cohérente sur toutes les pages.",
    benefits: [
      "Une image de marque plus premium qui inspire confiance aux vendeurs",
      "Des pages plus vivantes qui retiennent l'attention des visiteurs",
      "Une cohérence visuelle renforçant la crédibilité du réseau",
    ],
    links: [],
  },
  {
    id: "v2-3-0",
    date: "2026-07-14",
    time: "11:20",
    version: "2.3.0",
    category: "IA",
    phase: "ia",
    status: "available",
    developer: "Équipe OFF MARKETTE",
    title: "Home Staging par IA",
    description:
      "Génération à la demande, depuis le back-office, d'images de home staging à partir d'une vraie photo (architecture préservée). Styles Scandinave, Contemporain, Industriel et Luxe. Affichage public avec un curseur avant/après interactif.",
    benefits: [
      "Aider les acquéreurs à se projeter et accélérer les ventes",
      "Valoriser un bien vide ou à rafraîchir sans travaux",
      "Un argument différenciant face aux agences classiques",
    ],
    links: [],
  },
  {
    id: "v2-2-0",
    date: "2026-07-14",
    time: "15:05",
    version: "2.2.0",
    category: "Automatisations",
    phase: "ia",
    status: "available",
    developer: "Équipe OFF MARKETTE",
    title: "Création intelligente d'annonces (import URL)",
    description:
      "Import automatique depuis l'URL d'une annonce existante : extraction du titre, du prix, de la surface, des pièces et ré-hébergement des photos par IA, puis pré-remplissage de la fiche. Les biens importés sont créés en brouillon (hors ligne) avant publication.",
    benefits: [
      "Créer une fiche complète en quelques secondes au lieu de plusieurs minutes",
      "Zéro ressaisie manuelle des informations",
      "Un gain de temps considérable pour les conseillers",
    ],
    links: [],
  },
  {
    id: "v2-1-0",
    date: "2026-07-13",
    time: "09:40",
    version: "2.1.0",
    category: "IA",
    phase: "ia",
    status: "available",
    developer: "Équipe OFF MARKETTE",
    title: "Contenu de quartier généré par IA",
    description:
      "Sur chaque fiche, génération d'un contenu local (« Vivre à … ») : introduction, histoire, commerces, atouts et points d'intérêt géolocalisés avec carte interactive. Photos publiques réelles récupérées automatiquement.",
    benefits: [
      "Des fiches plus riches et rassurantes pour les acquéreurs",
      "Un meilleur référencement local",
      "Une présentation digne des plus belles agences",
    ],
    links: [],
  },
  {
    id: "v2-0-0",
    date: "2026-07-12",
    time: "18:30",
    version: "2.0.0",
    category: "Annonces",
    phase: "immersif",
    status: "available",
    developer: "Équipe OFF MARKETTE",
    title: "Template de fiche immersif unifié",
    description:
      "Toutes les annonces bénéficient désormais du template immersif haut de gamme : galerie plein écran, storytelling, sections dynamiques et protection par mot de passe (globale ou par bien).",
    benefits: [
      "Une expérience de visite en ligne mémorable",
      "Une présentation homogène et prestigieuse de tous les biens",
      "La confidentialité maîtrisée du off-market",
    ],
    links: [],
  },
  {
    id: "v1-5-0",
    date: "2026-07-10",
    time: "14:15",
    version: "1.5.0",
    category: "Nouveautés",
    phase: "immersif",
    status: "available",
    developer: "Équipe OFF MARKETTE",
    title: "« Proposez votre bien » (participatif)",
    description:
      "Un parcours propriétaire complet : soit via le lien d'une annonce existante (génération automatique), soit via un formulaire détaillé avec upload de photos et documents. Notification e-mail et validation en back-office.",
    benefits: [
      "Générer des mandats entrants directement depuis le site",
      "Alimenter le stock de biens off-market",
      "Une prise de contact simple pour les vendeurs",
    ],
    links: [],
  },
  {
    id: "v1-4-0",
    date: "2026-07-08",
    time: "10:50",
    version: "1.4.0",
    category: "IA",
    phase: "ia",
    status: "available",
    developer: "Équipe OFF MARKETTE",
    title: "Assistant conversationnel (chatbot IA)",
    description:
      "Un assistant intelligent répond aux questions des visiteurs sur les biens, avec un contexte adapté à chaque annonce.",
    benefits: [
      "Répondre aux acquéreurs 24h/24",
      "Qualifier les demandes automatiquement",
      "Décharger le conseiller des questions récurrentes",
    ],
    links: [],
  },
  {
    id: "v1-3-0",
    date: "2026-07-05",
    time: "17:10",
    version: "1.3.0",
    category: "SEO",
    phase: "fondations",
    status: "available",
    developer: "Équipe OFF MARKETTE",
    title: "SEO & performances",
    description:
      "Injection des métadonnées SEO par page (titres, descriptions, partage social) et optimisations de chargement.",
    benefits: [
      "Une meilleure visibilité sur Google",
      "Des partages soignés sur les réseaux et WhatsApp",
      "Un site plus rapide et plus fluide",
    ],
    links: [],
  },
  {
    id: "v1-2-0",
    date: "2026-07-01",
    time: "13:25",
    version: "1.2.0",
    category: "Back-office",
    phase: "fondations",
    status: "available",
    developer: "Équipe OFF MARKETTE",
    title: "Espace administrateur",
    description:
      "Back-office complet : création, édition, publication/dépublication des annonces, gestion des biens proposés et des vendeurs, authentification sécurisée.",
    benefits: [
      "Une gestion autonome et centralisée des annonces",
      "Un suivi clair des biens proposés",
      "Une base solide pour le futur multi-conseillers",
    ],
    links: [],
  },
  {
    id: "v1-1-0",
    date: "2026-06-25",
    time: "11:00",
    version: "1.1.0",
    category: "Back-office",
    phase: "fondations",
    status: "available",
    developer: "Équipe OFF MARKETTE",
    title: "Protection des annonces par mot de passe",
    description:
      "Verrouillage des fiches confidentielles avec un mot de passe global ou spécifique par bien.",
    benefits: [
      "Préserver la confidentialité des biens off-market",
      "Contrôler qui accède aux annonces sensibles",
    ],
    links: [],
  },
  {
    id: "v1-0-0",
    date: "2026-06-20",
    time: "19:00",
    version: "1.0.0",
    category: "Nouveautés",
    phase: "fondations",
    status: "available",
    developer: "Équipe OFF MARKETTE",
    title: "Lancement du site vitrine & des annonces",
    description:
      "Première mise en ligne : accueil dynamique, moteur de recherche, page annonces, fiches biens, pages Agence et Services.",
    benefits: [
      "Une vitrine professionnelle pour OFF MARKETTE",
      "Un point d'entrée unique pour vendeurs et acquéreurs",
    ],
    links: [],
  },
];

// Prochaines étapes majeures (jalons de version) — intégrés en bas de la timeline.
export const MILESTONES = [
  {
    id: "v1-launch",
    icon: "🚀",
    date: "2026-08-01",
    version: "1.0",
    phase: "jalons",
    title: "Lancement de la V1",
    status: "in_progress",
    statusLabel: "En cours de finalisation",
    description: "Première version officielle d'OFF MARKETTE, réunissant l'ensemble des fondations de la plateforme.",
    items: [
      "Gestion des annonces OFF MARKET",
      "Génération assistée par IA des fiches annonces",
      "Espace administrateur",
      "Formulaire « Proposez votre bien »",
      "Cartes interactives et galerie Masonry",
      "Gestion des vendeurs",
      "Site vitrine complet",
    ],
  },
  {
    id: "v2-launch",
    icon: "👥",
    date: "2026-08-15",
    version: "2.0",
    phase: "jalons",
    title: "Lancement de la V2 — Multi-conseillers",
    status: "in_progress",
    statusLabel: "Livré en préproduction — déploiement en cours",
    description: "La plateforme est désormais ouverte à plusieurs conseillers immobiliers : inscription, espace personnel, pages publiques, recherche avancée, statistiques et parrainage sont opérationnels. Déploiement progressif en production.",
    items: [
      "Gestion de plusieurs conseillers immobiliers",
      "Espace personnel pour chaque conseiller",
      "Répartition des annonces par conseiller",
      "Tableau de bord individuel",
      "Gestion des droits et des rôles",
      "Statistiques personnalisées",
      "CRM dédié à chaque conseiller",
      "Déploiement progressif du réseau OFF MARKETTE",
    ],
  },
  {
    id: "v3-launch",
    icon: "🎯",
    date: "2026-09-17",
    version: "3.0",
    phase: "jalons",
    title: "Lancement de la V3 — Agent IA & transactions digitalisées",
    status: "in_progress",
    statusLabel: "Livré en préproduction — déploiement en cours",
    description: "OFF MARKETTE devient une plateforme de prospection et de transaction de bout en bout : un agent IA (« Emma ») détecte les acquéreurs et prépare les mises en relation, un mini-CRM pilote chaque piste, et le parcours transactionnel (offre, avant-contrats, signature, co-mandat) se fait en ligne.",
    items: [
      "Agent IA de prospection multicanal (Emma)",
      "Mini-CRM des prospects (fiches, statuts, Kanban, visites)",
      "Relances et récapitulatifs automatiques",
      "Partenariats et co-mandats entre conseillers",
      "Boost des annonces (mise en avant payante)",
      "Sites personnalisés par réseau (Century 21…)",
      "Import d'annonce nouvelle génération avec aperçu",
      "Home staging IA sur l'ensemble des photos",
    ],
  },
];

// Vision — Et après ? (fonctionnalités encore à venir)
export const VISION = [
  { title: "Application mobile OFF MARKETTE", desc: "L'ensemble de vos annonces off-market, contacts et notifications dans votre poche, sur Android et iPhone." },
  { title: "Estimation immobilière par IA", desc: "Estimer un bien instantanément grâce à l'intelligence artificielle, avec une fourchette argumentée." },
  { title: "Publication en 1 clic sur Facebook & Instagram", desc: "Diffuser une annonce sur les réseaux Meta directement depuis la plateforme, dès la validation officielle de l'application par Meta." },
  { title: "Narration audio des annonces (voix IA)", desc: "Écouter la présentation d'un bien lue par une voix de synthèse naturelle, pour une découverte mains libres." },
  { title: "Agenda partagé", desc: "Coordonner rendez-vous et visites entre conseillers et acquéreurs sans friction." },
  { title: "Notifications push", desc: "Alertes en temps réel sur les nouveaux biens, contacts et étapes clés d'un dossier." },
  { title: "Automatisation avancée des campagnes marketing", desc: "Diffusion ciblée et automatisée auprès des bons profils, au bon moment." },
  { title: "Mandats numériques", desc: "Création et gestion 100 % dématérialisées des mandats, de la génération à l'archivage." },
  { title: "Déploiement national du réseau OFF MARKETTE", desc: "Étendre progressivement le réseau de conseillers partout en France." },
];

export const PRIVATE_KEY = "OFFMARKETTE60";
